class Trees extends Array {}

const tree_api_adapter = tree => {
    return tree;
};

const trees_api_adapter = trees => {
    return trees.map(tree_api_adapter);
};

const tree_view_adapter = tree => {
    // in front-end falsy values are "" or undefined or null
    // we must destructure object before its adaptation because
    // nested objects are still inmutable inside tree object

    tree["felling"] = !!tree["felling"];
    tree["cutting"] = !!tree["cutting"];
    if (!tree["cutting"]) {
        tree["number_of_logs"] = 0;
        tree["number_of_logs_ext"] = 0;
    }

    delete tree["created_by"];
    delete tree["updated_by"];
    delete tree["created_at"];
    delete tree["updated_at"];

    return tree;
};

const createTrees = (data = []) => {
    const trees = Trees.from(data, tree => createTree(tree));
    return trees;
};

const createTree = ({
    id = -1,
    code = "",
    species = "",
    quality = "",
    felling = null,
    cutting = null,
    is_felling_extended = null,
    is_cutting_extended = null,
    height = null,
    diameter = null,
    volume = null,
    comments = null,
    felling_fee = null,
    felling_price = null,
    number_of_logs = null,
    number_of_logs_ext = null,
    cutting_fee = null,
    cutting_price = null,
    geom = null,
    permit = null,
    created_by = "",
    updated_by = "",
    created_at = null,
    updated_at = null,
} = {}) => {
    const publicApi = {
        id,
        code,
        species,
        quality,
        felling,
        cutting,
        is_felling_extended,
        is_cutting_extended,
        height,
        diameter,
        volume,
        comments,
        felling_fee,
        felling_price,
        number_of_logs,
        number_of_logs_ext,
        cutting_fee,
        cutting_price,
        geom,
        permit,
        created_by,
        updated_by,
        created_at,
        updated_at,
    };

    return Object.freeze(publicApi);
};

export {
    createTree as default,
    createTrees,
    tree_api_adapter,
    trees_api_adapter,
    tree_view_adapter,
};
